import type { LandingPageContent } from '../types'

export const ZLECENIA_FOTOWOLTAICZNE_DLA_INSTALATOROW: LandingPageContent = {
  slug: 'zlecenia-fotowoltaiczne-dla-instalatorow',
  lang: 'pl',
  topicId: 'handwerker-photovoltaik-auftraege',
  title: 'Znajdź zlecenia fotowoltaiczne - bezpłatnie, bez abonamentu | Dla firm instalatorskich',
  metaDescription:
    'Przeglądaj zapytania fotowoltaiczne i składaj oferty bezpłatnie, bez abonamentu i minimalnego ' +
    'zakupu - kontakt z klientem dopiero po jego aktywnej zgodzie.',
  keywords: [
    'znajdź zlecenia fotowoltaika',
    'kup leady fotowoltaika',
    'bezpłatne leady fotowoltaika',
    'portal dla instalatorów fotowoltaiki bez abonamentu',
    'zapytania fotowoltaiczne firma instalatorska',
  ],
  eyebrow: 'Dla firm instalatorskich',
  h1: 'Znajdź zlecenia fotowoltaiczne - bezpłatnie, bez abonamentu',
  intro:
    'Roofora jest dla firm instalatorskich całkowicie bezpłatna: przeglądanie zapytań, składanie ' +
    'ofert, kontakt z klientami - bez abonamentu, bez minimalnego zakupu, bez kosztów wstępnych. ' +
    'Przeglądają Państwo zanonimizowane zapytania fotowoltaiczne ze swojego regionu i sami decydują, ' +
    'dla których złożyć ofertę.',
  sections: [
    { type: 'heading', text: 'Czym różni się to od klasycznych portali z leadami' },
    {
      type: 'paragraph',
      text:
        'Wiele portali sprzedaje firmom instalatorskim dane kontaktowe zainteresowanych - często za ' +
        'stałą cenę za lead, czasem w abonamencie lub z minimalnym zakupem, niezależnie od tego, czy ' +
        'z tego powstanie zlecenie. W Roofora widzą Państwo zamiast tego zanonimizowane zapytania, ' +
        'składają niewiążącą ofertę z ceną stałą, a dane kontaktowe otrzymują dopiero, gdy klient ' +
        'indywidualnie zaakceptuje właśnie Państwa firmę - bez zbiorowego przekazywania danych kilku ' +
        'firmom naraz.',
    },
    { type: 'heading', text: 'Jak to działa dla Państwa firmy' },
    {
      type: 'list',
      items: [
        'Bezpłatna rejestracja, bez zobowiązań abonamentowych',
        'Przeglądanie zanonimizowanych zapytań z Państwa regionu (obszar kodu pocztowego, dane dachu, zużycie)',
        'Składanie niewiążącej oferty z ceną stałą, w każdej chwili do zmiany',
        'Dane kontaktowe klienta dopiero po jego indywidualnej zgodzie dla Państwa firmy',
      ],
    },
    { type: 'heading', text: 'Bez oczekiwania zimnych telefonów z Państwa strony' },
    {
      type: 'paragraph',
      text:
        'Nie muszą Państwo do nikogo dzwonić, aby dostać zapytanie - wszystkie zapytania są już ' +
        'gotowe, zanonimizowane i czekają na Państwa ofertę. Nakład na analizę potrzeb i pierwszy ' +
        'kontakt, który gdzie indziej trzeba często wliczyć w cenę oferty, w dużej mierze tutaj odpada.',
    },
  ],
  faq: [
    {
      q: 'Czy rejestracja lub składanie ofert coś kosztuje?',
      a: 'Nie - korzystanie z Roofora jest dla firm instalatorskich obecnie całkowicie bezpłatne, bez abonamentu i bez minimalnego zakupu.',
    },
    {
      q: 'Czy automatycznie otrzymuję dane kontaktowe klienta po złożeniu oferty?',
      a: 'Nie - kontakt powstaje dopiero, gdy klient indywidualnie zaakceptuje Państwa firmę. Inne firmy mogą niezależnie składać oferty, bez automatycznego przekazywania danych kontaktowych wszystkim.',
    },
    {
      q: 'Ile innych firm widzi to samo zapytanie?',
      a: 'Widzą Państwo liczbę już złożonych ofert, ale nie ich ceny - swoją własną ofertę mogą Państwo w każdej chwili zmienić.',
    },
    {
      q: 'Na jakie rodzaje zleceń mogę się zarejestrować?',
      a: 'Systemy kompletne z montażem, sam montaż na dachu, instalacja elektryczna i pompa ciepła - zależnie od tego, jakie usługi oferuje Państwa firma.',
    },
  ],
  primaryCta: { label: 'Zarejestruj się bezpłatnie jako firma instalatorska', action: 'craftsman' },
  secondaryCta: { label: 'Jak działa porównanie ofert dla klientów?', action: 'link', href: '/porownaj-oferty-fotowoltaiczne' },
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
  ],
}
